export default {
	hasMinGamePassed() {
		// Contador de Juegos Jugados
		if (typeof window.gameSettings.gameMinPlayedToPreroll === "undefined") {
			return false;
		}
		if (window.gameSettings.gameMinPlayedToPreroll == 0) return true;
		const GamesPlayed = JSON.parse(sessionStorage.getItem("games_played"));
		if (GamesPlayed == null) return false;

		if (GamesPlayed.length >= window.gameSettings.gameMinPlayedToPreroll) {
			return true;
		}
		return false;
	},
	hasTimePassed() {
		if (typeof window.gameSettings.gameMinTimeToRePreroll === "undefined") {
			return false;
		}
		if (window.gameSettings.gameMinTimeToRePreroll == 0) return true;
		const now = new Date();
		const lastPreRoll = new Date(localStorage.getItem("lastPreRoll"));

		if (lastPreRoll == null) return false;
		if (
			now.getTime() - lastPreRoll.getTime()
			> window.gameSettings.gameMinTimeToRePreroll
		) {
			console.log(now.getTime() - lastPreRoll.getTime());
			return true;
		}
		return false;
	},

	showPrerol() {
		return this.hasMinGamePassed() && this.hasTimePassed();
	},
	store() {
		const now = new Date();
		localStorage.setItem("lastPreRoll", now);
	},
};
